import 'swiper/dist/css/swiper.css';

import VueAwesomeSwiper from 'vue-awesome-swiper';
export { swiper } from 'vue-awesome-swiper';
// @ts-ignore
export { SwiperOptions } from 'swiper';

export const Swiper = VueAwesomeSwiper.Swiper;
export const SwiperSlide = (VueAwesomeSwiper as any).SwiperSlide;

// // export type swiper =
// console.log('VAS', VueAwesomeSwiper);
// console.log('swiper', VueAwesomeSwiper.Swiper);
// console.log('swiper-slide', (VueAwesomeSwiper as any).SwiperSlide);
// console.log('asdfasdfasdf');
